export default __webpack_public_path__ + "static/media/icon-home.766f312e.svg";